export const ProductTypes = {
  PHONE: "phone",
  MODEM: "modem",
  YETTEL_HOME: "telenor_home",
  DRIVEY: "drivey",
  TABLET: "tablet",
  LAPTOP: "laptop",
  MYKI: "myki",
  BUNDLE_FTTH: "bundle_ftth",
  PURE_OTT: "pure_ott",
  POSTPAID_OTT: "bundle_post_ott",
  ROUTER: "router",
  STB: "stb",
  CORDLESS_PHONE: "cordless_phone",
  BLUETOOTH_HEADPHONE: "bt_headphone",
  PREPAID_INTERNET: "prepaid_internet",
  JEWLERY: "jewlery",
  PURSE: "purse",
  CHARGER: "charger",
  MEMORY: "memory",
  HEADPHONE: "headphone",
  ACCESSORY: "accessory",
  WATCH: "watch",
  WATCHES_BRACELETS: "watches_and_bracelets",
  SMART_BAND: "smart_band",
  TV: "tv",
  OPTICS_EQUIPMENT: "optics_equipment"
};

type ProductTypesKeys = keyof typeof ProductTypes;
export type ProductTypesType = typeof ProductTypes[ProductTypesKeys];

export default ProductTypes;
